<template>
  <el-dialog
          :title="dataForm.type===1?'批量导出':'批量导入'"
          :close-on-click-modal="false"
          :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px" style="text-align: left">

      <el-form-item label="日期" prop="month">
        <el-date-picker
                v-model="dataForm.month"
                value-format="yyyy-MM"
                type="month"
                placeholder="选择月">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="类型">
        <el-radio-group v-model="dataForm.type">
          <el-radio :label="0">导入</el-radio>
          <el-radio :label="1">导出</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="文件"  prop="file">
        <el-upload
                v-if="dataForm.type==0"
                action="#"
                :limit="1"
                :file-list="imgList"
                :on-remove="handleRemove"
                :http-request="httpRequest"
                :before-upload="beforeAvatarUpload">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <el-button type="primary" v-else-if="dataForm.type==1"  @click="exportPb">导出</el-button>
      </el-form-item>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" v-if="dataForm.type==0 && isAuth('kqcollect:batchin')" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { Loading } from 'element-ui';
  export default {
    data () {
      return {
        visible: false,
        dataForm: {
          bmid:'',
          month:'',
          file:'',
          filename:'',
          type:0
        },
        depts:[],
        imgList:[],
        deptdisable:false,
        dataRule: {
          month: [
            {required: true, message: '日期不能为空', trigger: 'blur'}
          ],
          type:[],
          file: [
            {required: true, message: '请上传文件', trigger: 'blur'}
          ]
        },
      }
    },
    methods: {
      init () {

          this.visible = true
          this.$nextTick(() => {
            this.$refs['dataForm'].resetFields()
            this.imgList=[]

          })

      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            let loadingInstance1 = Loading.service({ fullscreen: true });
            this.$http({
              url: `/bjba/kqcollectData/batchin/`,
              method: 'post',
              data: {
                'month': this.dataForm.month,
                'file': this.dataForm.file,
                'filename':this.dataForm.filename
              }
            }).then(({data}) => {
              loadingInstance1.close()
              if (data && data.code === 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500
                })
                this.visible = false
                this.$emit('refreshDataList')
              } else if(data && data.code === 500) {
                this.$message({
                  message: data.message,
                  type: 'error',
                  duration: 1500
                })
              }
            })
          }
        })
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
        this.dataForm.file=''
        this.dataForm.filename =''
      },
      beforeAvatarUpload(file){
        if(file.name.indexOf('.xls') >0 | file.name.indexOf('.xlsx')>0)
        return  true;
        else{
          this.$message.error('请上传excel文件')
          return  false
        }

      },
      exportPb() {
        if( this.dataForm.month) {
          var viewUrl = this.$request.defaults.baseURL + '/bjba/kqtj/exportExcelCollectAll?date=' + this.dataForm.month + '&access_token=' + this.$store.getters.token
          window.open(viewUrl)
        }else {
          this.$message.error("请选择日期")
        }
      },
      httpRequest(data){
        let _that=this;
        let rd = new FileReader(); // 创建文件读取对象
        let file = data.file;
        this.dataForm.filename = data.file.name
        var that = this;
        rd.readAsDataURL(file); // 文件读取装换为base64类型
        rd.onloadend = function (e) {
          console.log(e)
          that.dataForm.file = e.currentTarget.result
        }
      },

    }
  }
</script>
